var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import { Alert, DrawerBody, Skeleton, SkeletonLine, Typography, } from '@one-thd/sui-atomic-components';
import { ArrowForward, WarningFilled } from '@one-thd/sui-icons';
import { ChallengesContext, InfoOffersContext, RewardsAndOffersContext, } from '../../../../contexts';
import { DrawerContext } from '../../../../contexts/drawer-context';
import { ChallengeTile } from '../ChallengeDrawer/ChallengeTile';
import { useIsMobile } from '../../../../hooks';
import { rhAnalytics, rhDrawer } from '../../../../constants/RewardsHub';
import { ExpireMessage, ListDrawerHeader, } from '../PerkDrawer/PerkListComponents';
import { analyticsOverlay } from '../../../../utils/analytics';
import { fallbackImage } from '../../../../images';
import { removeFromUrlParams } from '../../../Utils';
import { useDisplayAmount } from '../../../../utils/PerkOptionsUtil';
import { DrawerEventTriggers } from '../../../../utils/DrawerEventUtils';
export var OffersListDrawer = function () {
    var _a;
    var _b = React.useContext(InfoOffersContext), offerList = _b.offerList, perksInfo = _b.perksInfo, finishOfferLoad = _b.finishOfferLoad, isLoading = _b.isLoading, setIsLoading = _b.setIsLoading, getPerksInfoOffersData = _b.getPerksInfoOffersData, hasError = _b.hasError, refreshOffers = _b.refreshOffers;
    var _c = React.useContext(DrawerContext), setDrawerOpen = _c.setDrawerOpen, onDrawerClose = _c.onDrawerClose, onBackFromPAC = _c.onBackFromPAC, openDetailsOffers = _c.openDetailsOffers, isPacDrawersEnabled = _c.isPacDrawersEnabled;
    var rewardsAndOffers = React.useContext(RewardsAndOffersContext).rewardsAndOffers;
    var _d = React.useContext(ChallengesContext), challengesInfo = _d.challengesInfo, // Get all challenges
    isChallengeLoading = _d.isChallengeLoading, hasChallengeError = _d.hasChallengeError, getChallengesInfo = _d.getChallengesInfo, hideChallenge = _d.hideChallenge;
    var getDisplayAmount = useDisplayAmount();
    var availableActiveOffers = (_a = rewardsAndOffers === null || rewardsAndOffers === void 0 ? void 0 : rewardsAndOffers.perkAccrualSummary) === null || _a === void 0 ? void 0 : _a.availableActiveOffers;
    React.useEffect(function () {
        analyticsOverlay(rhAnalytics.offersAvailableDrawer);
    }, []);
    React.useEffect(function () {
        if (availableActiveOffers && isLoading) {
            if (perksInfo)
                finishOfferLoad(perksInfo);
            if (!perksInfo || !!(perksInfo === null || perksInfo === void 0 ? void 0 : perksInfo.errors))
                getPerksInfoOffersData();
        }
    }, [isLoading]);
    // Filter for active challenges that should be shown
    var activeChallenges = ((challengesInfo === null || challengesInfo === void 0 ? void 0 : challengesInfo.challenges) || []).filter(function (ch) {
        return (ch === null || ch === void 0 ? void 0 : ch.challengeStatus) === 'ACTIVE' && !hideChallenge(ch);
    });
    // Update count to include offers and all active challenges
    var offerCountNum = ((offerList === null || offerList === void 0 ? void 0 : offerList.length) || 0) + ((activeChallenges === null || activeChallenges === void 0 ? void 0 : activeChallenges.length) || 0);
    var isMobile = useIsMobile().isMobile;
    var handleClose = function () {
        removeFromUrlParams('drawerList');
        setDrawerOpen(false);
    };
    var slides = offerList === null || offerList === void 0 ? void 0 : offerList.map(function (perk, index) {
        var eventOutput = {
            perkObj: perk,
            onClose: onDrawerClose,
            onBack: function () { return onBackFromPAC('OffersList'); },
        };
        var onClick = function () {
            if (isPacDrawersEnabled) {
                setDrawerOpen(false);
                DrawerEventTriggers.triggerRewardBarcodeDrawer(eventOutput);
            }
            else
                openDetailsOffers({ perk: perk, eventOutput: eventOutput, showBack: true });
        };
        return (React.createElement("button", { className: "sui-w-full sui-rounded-base sui-border-1 sui-border-solid sui-border-primary sm:sui-border-0 sui-mb-8", key: "card-".concat(index), onClick: onClick, type: "button" },
            React.createElement("div", { className: "sui-rounded-base sui-border-1 sui-border-primary sui-w-full sui-flex sui-flex-row sui-justify-between sui-p-4 sm:sui-p-0" },
                React.createElement("div", { className: "sui-flex sui-flex-row sui-justify-start sui-align-start" },
                    React.createElement("img", { className: "sui-h-12 sui-w-12", src: perk.perkImageUrl, alt: "Perks", height: "48", width: "48", onError: fallbackImage }),
                    React.createElement("div", { className: "sui-flex sui-flex-col sui-justify-center sui-align-start sui-pl-6" },
                        React.createElement("div", { className: "sui-font-bold sui-text-base sm:sui-text-lg sui-text-left" }, "".concat(getDisplayAmount(perk)).concat(perk.perkTitle)),
                        React.createElement("div", { className: "sui-text-base sui-flex sui-flex-row sui-justify-start sui-pt-3" }, perk.daysLeft < 14 ? (React.createElement("div", { className: "sui-flex" },
                            React.createElement("span", { className: "sui-pr-2" },
                                React.createElement(WarningFilled, { color: "warning" })),
                            React.createElement(ExpireMessage, { numOfDays: perk.daysLeft }))) : (React.createElement("div", null,
                            "Expires ",
                            perk.expirationTime))))),
                React.createElement("div", { className: "sui-flex sui-flex-col sui-justify-center" },
                    React.createElement("span", { className: "sui-text-brand" },
                        React.createElement(ArrowForward, { size: isMobile ? 'small' : 'regular' }))))));
    });
    // Create a slide component for each active challenge
    var challengeSlides = function () {
        return activeChallenges.length
            ? activeChallenges.map(function (challenge, idx) { return (React.createElement(ChallengeTile, { key: "challengeTile-".concat(idx), challenge: challenge, inListDrawer: true, isFirstTile: idx === 0 })); })
            : [];
    };
    // Combine challenges and offers into a single list of slides
    var combinedSlides = __spreadArray(__spreadArray([], challengeSlides(), true), (slides || []), true);
    var OfferAndChallengeError = function () {
        return (React.createElement(Alert, { status: "error" },
            React.createElement("div", null,
                React.createElement(Typography, null, rhDrawer.PerkErrorMessage),
                React.createElement("div", { className: "sui-text-base" },
                    React.createElement("button", { type: "button", onClick: function () {
                            refreshOffers();
                            getPerksInfoOffersData();
                            getChallengesInfo();
                        } },
                        React.createElement("u", null, "Refresh"))))));
    };
    var ChallengeErrorSection = function () {
        return (React.createElement("div", { className: "sui-pb-4" },
            React.createElement(Alert, { status: "error" },
                React.createElement("div", null,
                    React.createElement(Typography, null, rhDrawer.challengeErrorMessage),
                    React.createElement("div", { className: "sui-text-base" },
                        React.createElement("button", { type: "button", onClick: function () { return getChallengesInfo(); } },
                            React.createElement("u", null, "Refresh")))))));
    };
    var OfferSlideSection = function () {
        return (React.createElement(React.Fragment, null, offerCountNum === 0 ? (React.createElement(Alert, { status: "warning" }, rhDrawer.noOffers)) : (
        // This will now render the combined list
        React.createElement(OfferSlides, null))));
    };
    var OfferListBody = function () {
        return (React.createElement("div", null, hasError && hasChallengeError ? (React.createElement(OfferAndChallengeError, null)) : (React.createElement(OfferSlideSection, null))));
    };
    var OfferSlides = function () {
        if (hasError) {
            return (React.createElement("div", { className: "sui-flex sui-flex-col" },
                React.createElement(Alert, { status: "error" },
                    React.createElement("div", null,
                        React.createElement(Typography, null, rhDrawer.PerkErrorMessage),
                        React.createElement("div", { className: "sui-text-base" },
                            React.createElement("button", { type: "button", onClick: function () {
                                    refreshOffers();
                                    getPerksInfoOffersData();
                                } },
                                React.createElement("u", null, "Refresh")))))));
        }
        // If challenges failed but offers loaded successfully, show challenge error above the offers
        if (hasChallengeError) {
            return (React.createElement("div", { className: "sui-flex sui-flex-col" },
                React.createElement(ChallengeErrorSection, null),
                React.createElement("div", { className: "sui-flex sui-flex-col" }, slides || [])));
        }
        // Render the combined list of challenges and offers
        return React.createElement("div", { className: "sui-flex sui-flex-col" }, combinedSlides);
    };
    var offerCount = offerCountNum === 0 ? "" : "(".concat(offerCountNum, ")");
    return (React.createElement(React.Fragment, null,
        React.createElement(ListDrawerHeader, { title: "Offers Available ".concat(offerCount), handleClose: handleClose }),
        React.createElement(DrawerBody, null,
            React.createElement("div", { className: isMobile ? '' : 'sui-px-2 sui-pb-2' },
                React.createElement("div", { className: "sui-pb-10 sui-text-base" }, isMobile
                    ? rhDrawer.OffersListInfoMobile
                    : rhDrawer.OffersListInfoDesktop),
                isChallengeLoading || isLoading ? (React.createElement(SlidesSkeleton, null)) : (React.createElement(OfferListBody, null))))));
};
var SlidesSkeleton = function () {
    return (React.createElement(Skeleton, { grow: true },
        React.createElement(SkeletonLine, { variant: "multi", numberOfLines: 9 })));
};
